import { gsap } from "gsap"
import { isAllMobileDevices, awdScroll, riseAndFadeIn, riseAndFadeOut } from "./bundle"

class Goals{
    constructor(container){
        // console.log(container)
        this.container = container
        this.awdScroll = awdScroll
        this.popup = this.container.querySelector('.popup-goals')
        this.popupContainer = this.popup.querySelector('.popup-goals__container')
        this.popupBgSpan = this.popup.querySelector('.popup-goals__bg span')
        this.popupLista = this.popup.querySelector('.popup-goals__wrapper')
        this.popupListaBgSpan = this.popup.querySelector('.popup-goals__lista .lista__bg span')
        this.listaClose = this.popup.querySelector('.lista__close')
        // this.listaContainer = this.popup.querySelector('.lista__container')
        this.listaCenter = this.popup.querySelector('.lista__center')
        this.openPopupBtns = this.container.querySelectorAll('.open-popup-goals-btn')
        this.closePopupBtns = this.container.querySelectorAll('.close-popup-goals-btn')

        //Scroll to
        this.scrollToSDG = this.container.querySelector('.scroll-to-sdg')
        this.target = this.container.querySelector('.sezione-goals')
        this.offset = 100

        //External
        this.header = document.querySelector('header')        

        //Bool
        this.isAnimating = false

        this.initEvents()
    }

    initEvents(){
        this.clickToScrollDown()
        this.openPopupBtns.forEach( openPopupBtn => {
            openPopupBtn.addEventListener('click', () => {
                if(this.isAnimating) return
                this.isAnimating = true
                let qualeGoal = openPopupBtn.getAttribute('data-quale-goal')
                this.openPopup(qualeGoal)
            })
        })
        this.closePopupBtns.forEach( closePopupBtn => {
            closePopupBtn.addEventListener('click', () => {
                if(this.isAnimating) return
                this.isAnimating = true
                this.closePopup()
            })
        })
    }


    openPopup(qualeGoal){
        this.awdScroll.stop()
        this.header.classList.remove('active')
        this.header.classList.add('header-bloccato')
        this.popup.classList.add('opened')
        let zIndex = 19
        if(isAllMobileDevices){
            zIndex = 3900
            document.querySelector('body').style.overflow = 'hidden'
        }
        //Temporaneamente disabilito lo scroll al goal selezionato
        // let goalTatrgetToScroll = this.popup.querySelector(`.goal[data-quale-goal="${qualeGoal}"]`)
        // console.log(goalTatrgetToScroll)
        // gsap.set(this.popupLista, {
        //     scrollTo: {
        //         y: goalTatrgetToScroll,
        //         offsetY: 70
        //     }
        // })  
        gsap.set(this.popup,{
            'pointer-events': 'auto',
            'z-index': zIndex
        })
        gsap.set(this.popupContainer,{
            y: '0%'
        })        
        gsap.to(this.popupBgSpan, {
            duration: 1.2,
            width: '100%',
            ease: 'power2.inOut'
        })
        gsap.to(this.popupListaBgSpan,{
            duration: 1.2,
            delay: 0.4,
            width: '100%',
            ease: 'power2.inOut',
            onComplete: () => {
                this.isAnimating = false
            }
        })
        riseAndFadeIn(this.listaClose,{delay: 0.8})
        riseAndFadeIn(this.listaCenter, {delay: 1.2})

    }

    closePopup(){
        riseAndFadeOut(this.listaClose,{destination: 0})
        riseAndFadeOut(this.listaCenter)
        gsap.to(this.popupListaBgSpan,{
            duration: 0.6,
            delay: 0.4,
            width: '0%',
            ease: 'power2.inOut'
        })
        gsap.to(this.popupBgSpan, {
            duration: 0.8,
            delay: 0.45,
            width: '0%',
            ease: 'power2.inOut',
            onComplete: () => {
                this.resetPopupAcquista()
                this.isAnimating = false
                if(isAllMobileDevices){
                    document.querySelector('body').style.overflow = 'visible'
                }
            }
        })

    }
    resetPopupAcquista(){
        this.awdScroll.start()
        this.header.classList.add('active')
        this.header.classList.remove('header-bloccato')
        this.popup.classList.remove('opened')
        gsap.set(this.popup,{
            'pointer-events': 'none',
            'z-index': -1
        })
        gsap.set(this.popupContainer,{
            y: '-100%'
        })
    }

    callBack(){
        
    }

	clickToScrollDown(){
        // var $ = jQuery
		this.scrollToSDG.addEventListener('click', () => {
            // console.log(this.isAnimating)
            if(!isAllMobileDevices){
                if(this.isAnimating) return
                this.isAnimating = true
            }
			let options = {
				offset: this.offset,
				duration: 1200,
				easing: [0.62, 0.02, 0.38, 0.98],
				callback: () => {
					this.isAnimating = false
                    console.log(this.isAnimating)
				}
			}
            if(!isAllMobileDevices){
                this.awdScroll.scrollTo(this.target,options)
            }
            else{
               gsap.to(window, {
                   duration: 1.2,
                   ease: 'power2.inOut',
                   scrollTo: this.target
               })     

            }
		})
	}    
}


export {Goals}